(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var stage = document.querySelector('[data-ab-timeline]');
  if(!stage) return;

  var tabs = Array.prototype.slice.call(stage.querySelectorAll('.ab-timeline-year'));
  var panel = stage.querySelector('.ab-timeline-panel');
  var media = stage.querySelector('[data-ab-media]');
  var image = stage.querySelector('[data-ab-image]');
  var bg = stage.querySelector('[data-ab-bg]');
  var period = stage.querySelector('[data-ab-period]');
  var heading = stage.querySelector('[data-ab-heading]');
  var text = stage.querySelector('[data-ab-text]');
  var tagWrap = stage.querySelector('[data-ab-tags]');
  if(!tabs.length || !panel) return;
  var currentIndex = 0;

  function render(tab){
    var img = tab.getAttribute('data-image');
    if(image){ image.src = img; image.alt = tab.getAttribute('data-alt') || ''; }
    if(bg){ bg.src = img; }
    if(period){ period.textContent = tab.getAttribute('data-period') || ''; }
    if(heading){ heading.textContent = tab.getAttribute('data-heading') || ''; }
    if(text){ text.textContent = tab.getAttribute('data-text') || ''; }
    if(tagWrap){
      tagWrap.innerHTML = '';
      var tags = (tab.getAttribute('data-tags') || '').split('|');
      tags.forEach(function(label){
        label = label.trim();
        if(!label) return;
        var span = document.createElement('span');
        span.textContent = label;
        tagWrap.appendChild(span);
      });
    }
  }

  function activate(tab, focusPanel){
    var idx = tabs.indexOf(tab);
    if(idx === currentIndex && tab.getAttribute('aria-selected') === 'true'){
      if(focusPanel) panel.focus();
      return;
    }
    tabs.forEach(function(item){
      var active = item === tab;
      item.setAttribute('aria-selected', String(active));
      item.tabIndex = active ? 0 : -1;
    });
    panel.setAttribute('aria-labelledby', tab.id);

    if(!reduce && document.startViewTransition){
      document.documentElement.dataset.abvt = idx >= currentIndex ? 'fwd' : 'back';
      currentIndex = idx;
      var t = document.startViewTransition(function(){ render(tab); });
      if(focusPanel) t.finished.then(function(){ panel.focus(); }, function(){ panel.focus(); });
      return;
    }
    currentIndex = idx;
    if(reduce){ render(tab); if(focusPanel) panel.focus(); return; }

    media.classList.add('changing');
    window.setTimeout(function(){
      render(tab);
      media.classList.remove('changing');
      if(focusPanel) panel.focus();
    }, 170);
  }

  tabs.forEach(function(tab){
    tab.addEventListener('click', function(){ activate(tab, false); });
    tab.addEventListener('mouseenter', function(){ activate(tab, false); });
    tab.addEventListener('keydown', function(event){
      var current = tabs.indexOf(tab);
      var next = null;
      if(event.key === 'ArrowRight') next = (current + 1) % tabs.length;
      if(event.key === 'ArrowLeft') next = (current - 1 + tabs.length) % tabs.length;
      if(event.key === 'Home') next = 0;
      if(event.key === 'End') next = tabs.length - 1;
      if(next !== null){
        event.preventDefault();
        tabs[next].focus();
        activate(tabs[next], false);
      }
    });
  });
})();
